import Repository from "@/utils/Repository";
import RepositoryGeneral from "@/utils/RepositoryGeneral";
import { RepositoryFactory, AUTH_REPOSITORY } from "@/utils/RepositoryFactory";
import {
  RepositoryFactoryGeneral,
  AUTH_REPOSITORY_GENERAL
} from "@/utils/RepositoryFactoryGeneral";
import {
  LOGIN,
  LOGOUT,
  RESET_PASSWORD,
  SET_PASSWORD,
  CHECK_TOKEN,
  LOGIN_GENERAL,
  RESET_PASSWORD_GENERAL,
  SET_PASSWORD_GENERAL,
  CHECK_TOKEN_GENERAL
} from "../action-types";
const AuthRepository = RepositoryFactory.get(AUTH_REPOSITORY);
const AuthRepositoryGeneral = RepositoryFactoryGeneral.get(
  AUTH_REPOSITORY_GENERAL
);
import router from "@/router";
import { RESET_STATE } from "../mutation-types";

const getDefaultState = () => ({
  isLoggedIn: true,
  status: "",
  message: "",
  token: sessionStorage.getItem("token") || localStorage.getItem("token") || "",
  tokenExpirationDate:
    parseInt(sessionStorage.getItem("tokenExpirationDate")) ||
    parseInt(localStorage.getItem("tokenExpirationDate")) ||
    "",
  user:
    JSON.parse(sessionStorage.getItem("user")) ||
    JSON.parse(localStorage.getItem("user")) ||
    {}
});

const state = getDefaultState();

Repository.defaults.headers.common["Token"] = state.token;
RepositoryGeneral.defaults.headers.common["Token"] = state.token;

const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  hasAdminRights: state => {
    let adminRight = state.user.acces
      .filter(
        acces =>
          acces.abonnement.application.id ==
          "ad7a41de-9817-41a0-b4c0-22a0ffeb22b6"
      )
      .find(acces => acces.droit.code == "admin");

    return !!adminRight; // Return true if not null
    // (state.user && state.user.admin ? true : false);
  },
  // eslint-disable-next-line no-unused-vars
  hasDelegueRights: state => true
};

const mutations = {
  auth_request(state) {
    state.status = "loading";
  },
  auth_success(state, { user, token, tokenExpirationDate }) {
    state.status = "success";
    state.token = token;
    state.tokenExpirationDate = tokenExpirationDate;
    state.user = user;
  },
  auth_error(state, { message }) {
    state.status = "error";
    state.message = message;
  },
  logout(state) {
    state.status = "";
    state.token = "";
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  [LOGIN]({ commit }, { email, password, stayLoggedIn = false }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      return AuthRepository.login({ email, password })
        .then(res => {
          const token = res.data.content.token.value;
          let tokenExpirationDate = new Date();
          tokenExpirationDate.setSeconds(
            tokenExpirationDate.getSeconds() + res.data.content.token.expiry
          );
          tokenExpirationDate = tokenExpirationDate.getTime();
          const user = res.data.content.entity;
          if (stayLoggedIn) {
            localStorage.setItem("token", token);
            localStorage.setItem("tokenExpirationDate", tokenExpirationDate);
            localStorage.setItem("user", JSON.stringify(user));
          } else {
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("tokenExpirationDate", tokenExpirationDate);
            sessionStorage.setItem("user", JSON.stringify(user));
          }
          Repository.defaults.headers.common["Token"] = token;
          commit("auth_success", {
            user,
            token,
            tokenExpirationDate
          });
          resolve(res);
        })
        .catch(err => {
          let message = null;
          if (err.response && err.response.data) {
            message = err.response.data.message;
          }
          commit("auth_error", { message });
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  [LOGIN_GENERAL]({ commit }, { email, password, stayLoggedIn = false }) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      return AuthRepositoryGeneral.login({ email, password })
        .then(res => {
          const token = res.data.content.token.value;
          let tokenExpirationDate = new Date();
          tokenExpirationDate.setSeconds(
            tokenExpirationDate.getSeconds() + res.data.content.token.expiry
          );
          tokenExpirationDate = tokenExpirationDate.getTime();
          const user = res.data.content.entity;
          if (stayLoggedIn) {
            localStorage.setItem("token", token);
            localStorage.setItem("tokenExpirationDate", tokenExpirationDate);
            localStorage.setItem("user", JSON.stringify(user));
          } else {
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("tokenExpirationDate", tokenExpirationDate);
            sessionStorage.setItem("user", JSON.stringify(user));
          }
          RepositoryGeneral.defaults.headers.common["Token"] = token;
          commit("auth_success", {
            user,
            token,
            tokenExpirationDate
          });
          resolve(res);
        })
        .catch(err => {
          let message = null;
          if (err.response && err.response.data) {
            message = err.response.data.message;
          }
          commit("auth_error", { message });
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },
  [LOGOUT]({ commit }) {
    return new Promise(resolve => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpirationDate");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("tokenExpirationDate");
      sessionStorage.removeItem("user");

      commit(`app/${RESET_STATE}`, {}, { root: true });
      commit(`auth/${RESET_STATE}`, {}, { root: true });
      commit(`user/${RESET_STATE}`, {}, { root: true });
      commit(`user/createForm/${RESET_STATE}`, {}, { root: true });
      commit(`user/searchForm/${RESET_STATE}`, {}, { root: true });
      commit(`company/${RESET_STATE}`, {}, { root: true });
      commit(`company/createForm/${RESET_STATE}`, {}, { root: true });
      commit(`company/searchForm/${RESET_STATE}`, {}, { root: true });

      delete Repository.defaults.headers.common["Token"];
      if (router.history.current.name != "login") {
        router.replace({ name: "login" });
      }
      resolve();
    });
  },
  // eslint-disable-next-line no-unused-vars
  [RESET_PASSWORD]({ commit }, { email, callbackUrl }) {
    return new Promise((resolve, reject) => {
      return AuthRepository.resetPassword({ email, callbackUrl })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  [RESET_PASSWORD_GENERAL]({ commit }, { email, callbackUrl }) {
    return new Promise((resolve, reject) => {
      return AuthRepositoryGeneral.resetPassword({ email, callbackUrl })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  [SET_PASSWORD]({ commit }, { password, token }) {
    return new Promise((resolve, reject) => {
      return AuthRepository.setPassword({ password, token })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  [SET_PASSWORD_GENERAL]({ commit }, { password, token }) {
    return new Promise((resolve, reject) => {
      return AuthRepositoryGeneral.setPassword({ password, token })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  [CHECK_TOKEN]({ commit }, { token }) {
    return new Promise((resolve, reject) => {
      return AuthRepository.checkToken({ token })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  [CHECK_TOKEN_GENERAL]({ commit }, { token }) {
    return new Promise((resolve, reject) => {
      return AuthRepositoryGeneral.checkToken({ token })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
